import { ethers } from "ethers";
import { DECIMALS } from "./constants";

export const ZERO = ethers.constants.Zero;

export const toWei = (v: string): ethers.BigNumber => {
  try {
    if (!v) return ZERO;
    const norm = v.toString().replace(",", ".").trim();
    if (!norm) return ZERO;
    return ethers.utils.parseUnits(norm, DECIMALS);
  } catch {
    return ZERO;
  }
};

export const weiToStr = (bn: ethers.BigNumber): string => 
  ethers.utils.formatUnits(bn, DECIMALS);

export const clampWei = (valWei: ethers.BigNumber, maxWei: ethers.BigNumber) =>
  valWei.gt(maxWei) ? maxWei : valWei;

export const signWithTimeout = <T,>(p: Promise<T>, ms = 45000) =>
  Promise.race<T>([
    p,
    new Promise<never>((_, rej) =>
      setTimeout(() => rej(new Error("Timeout: MetaMask nie odpowiedział")), ms)
    ),
  ]);